import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body pt-0" }
const _hoisted_3 = { class: "svg-icon overflow-hidden" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fs-3 me-5 bi bi-caret-right" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fs-3 bi bi-telephone" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterBox = _resolveComponent("FilterBox")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Entitytable = _resolveComponent("Entitytable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_FilterBox, {
      onChanged: _cache[0] || (_cache[0] = 
      () => {
        _ctx.$refs.pingo.resetPage();
        _ctx.$refs.pingo.retrieveData();
      }
    ),
      applied_filters: _ctx.filters,
      show_tz: true
    }, null, 8, ["applied_filters"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Entitytable, {
          ref: "pingo",
          "entity-name": "lead",
          "resource-name": "leads",
          "filter-data": _ctx.filters,
          "show-pagination": true
        }, {
          "column-status": _withCtx((lead) => [
            _createElementVNode("div", null, [
              _createElementVNode("span", {
                class: _normalizeClass(['badge', lead.entity.status.class]),
                "data-kt-menu-trigger": "click",
                "data-kt-menu-placement": "bottom-end",
                "data-kt-menu-flip": "top-end"
              }, _toDisplayString(lead.entity.status.label), 3)
            ])
          ]),
          "column-offer": _withCtx((lead) => [
            _createTextVNode(_toDisplayString(lead.entity.offer.name), 1)
          ]),
          "column-date": _withCtx((lead) => [
            _createTextVNode(_toDisplayString(_ctx.getDate(lead.entity.date)), 1)
          ]),
          "column-vertical": _withCtx((lead) => [
            _createTextVNode(_toDisplayString(lead.entity.vertical.label), 1)
          ]),
          "column-country": _withCtx((lead) => [
            _createElementVNode("span", _hoisted_3, [
              _createVNode(_component_inline_svg, {
                class: "rounded-circle",
                src: lead.entity.country.flag
              }, null, 8, ["src"])
            ]),
            _createTextVNode(" " + _toDisplayString(lead.entity.country.shortname), 1)
          ]),
          "column-actions": _withCtx(() => [
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        }, 8, ["filter-data"])
      ])
    ])
  ], 64))
}